import styled from 'styled-components';

export const StyledTooltipText = styled.div`
   span {
      line-break: auto;
   }
`;

StyledTooltipText.displayName = 'StyledTooltipText';
